import { Alert } from "plos/src/components/alerts";
import { Trans } from "react-i18next";

const LatestAlert = () => {
  const showAlert = false;
  if (!showAlert) {
    return null;
  }
  return (
    <Alert variant="default" isContentCentered>
      <Trans ns="common" i18nKey={"latestAlert"}>
        Gameweek 17 will remain open after the conclusion of Sunday’s matches.
        More information will follow in due course.
      </Trans>
    </Alert>
  );
};

export default LatestAlert;
